import {
  Box,
  Flex,
  Heading,
  HStack,
  Skeleton,
  SkeletonCircle,
  SkeletonText,
  Spacer,
} from "@chakra-ui/react";
import React from "react";
function UISkeletons() {
  return (
    <>
      <Box
        bg="whitesmoke"
        maxW="250px"
        padding="0"
        marginInline="5px"
        marginBlock="10px"
        rounded="lg"
        height="fit-content"
        shadow="lg"
      >
        <Skeleton
          roundedTop="lg"
          maxHeight="250px"
          height="230px"
          fit="cover"
        />

        <SkeletonText mt="4" noOfLines={4} spacing="4" />
        <Skeleton
          margin="auto"
          width="40"
          height="10"
          mt="4"
          border="1px"
          borderRadius="5px"
        />
      </Box>
    </>
  );
}
export default UISkeletons;
